import { PARTNER_COMPANIES } from "../../data/servicesData";

export function InfiniteSlider() {
  const items = [...PARTNER_COMPANIES, ...PARTNER_COMPANIES];

  return (
    <div
      data-testid="infinite-slider"
      className="py-10 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #0f172a, #1e1b4b)" }}
    >
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 z-10" style={{ background: "linear-gradient(to right, #0f172a, transparent)" }} />
      <div className="absolute right-0 top-0 bottom-0 w-24 z-10" style={{ background: "linear-gradient(to left, #0f172a, transparent)" }} />

      <p className="text-center text-slate-500 text-[11px] font-bold tracking-[0.2em] uppercase mb-6 font-body px-4">
        Trusted by 500+ companies across India, UAE, USA & <span className="text-slate-400 font-extrabold">globally</span>
      </p>

      <div className="flex gap-6 items-center animate-scroll-left w-max">
        {items.map((co, i) => (
          <div
            key={i}
            className="flex items-center gap-2.5 px-5 py-2 rounded-full border border-white/[0.08] bg-white/[0.04] whitespace-nowrap"
          >
            <div className="w-7 h-7 bg-gradient-to-br from-red-600 to-red-700 rounded-full flex items-center justify-center text-white text-[11px] font-extrabold flex-shrink-0">
              {co[0]}
            </div>
            <span className="text-slate-400 font-medium text-[13px] font-body">{co}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
